import { useState, useCallback } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input } from "@mui/base/Input";
import CustomButton from "components/Button/Button";
import FormCheckbox from "components/FormCheckbox/FormCheckbox";
import { EMAIL_REGEXP } from "constants/validation";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAppDispatch } from "store";
import { exchangeActions } from "../../../store/reducers/exchange";
import { logIn } from "store/reducers/signIn";

const validationSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .matches(EMAIL_REGEXP, "Email is incorrect"),
    password: Yup.string().required("Password is required"),
  });
};

const SignInForm = () => {
  const dispatch = useAppDispatch();

  const setIsForgotPassword = useCallback(() => {
    dispatch(exchangeActions.setComponentsName("ForgotPassword"));
  }, [dispatch]);

  const [isRememberMe, setIsRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="signin-container">
      <div className="signin-title">Sign In</div>
      <Formik
        initialValues={{ email: "", password: "", isRememberMe: false }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          dispatch(
            logIn({
              request: { email: values.email, password: values.password },
              isRememberMe: isRememberMe,
            })
          );
        }}
      >
        {({
          values,
          errors,
          touched,
          isValid,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => {
          return (
            <Form className="signin-form">
              <Input
                name="email"
                type="text"
                placeholder="Email"
                id="email"
                autoComplete="on"
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  setFieldValue("email", e.target.value.trim());
                }}
                className={
                  touched.email && errors.email
                    ? "error-field signin-input"
                    : "signin-input"
                }
              />
              <ErrorMessage
                name={"email"}
                render={(msg) => (
                  <div className="error-message">
                    <InfoOutlinedIcon />
                    {msg}
                  </div>
                )}
              />
              <Input
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                id="password"
                autoComplete="on"
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                }}
                className={
                  touched.password && errors.password
                    ? "error-field signin-input"
                    : "signin-input"
                }
                endAdornment={
                  <IconButton
                    size="small"
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <VisibilityOff fontSize="large" />
                    ) : (
                      <Visibility fontSize="large" />
                    )}
                  </IconButton>
                }
              />
              <ErrorMessage
                name={"password"}
                render={(msg) => (
                  <div className="error-message">
                    <InfoOutlinedIcon />
                    {msg}
                  </div>
                )}
              />
              <div className="mb-4 checkbox-section">
                <FormCheckbox
                  checked={isRememberMe}
                  name="isRememberMe"
                  onChange={(e) => {
                    setIsRememberMe(!isRememberMe);
                    handleChange(e);
                  }}
                />
                <div className="checkbox-title">Remember me</div>
              </div>
              <CustomButton
                type="submit"
                btnName="Continue"
                className="blue-btn"
                disabled={
                  !isValid || !values.email.length || !values.password.length
                }
              />
            </Form>
          );
        }}
      </Formik>
      <div className="forgot-password" onClick={() => setIsForgotPassword()}>
        <InfoOutlinedIcon />
        Forgot password?
      </div>
    </div>
  );
};
export default SignInForm;
